import { CheckCircleFilled } from '@ant-design/icons';
import { Button, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { OperationBriefForm } from 'models/OperationRequest';

import { OPS_UNIFORMS, formatClp } from '../data/operationCatalogs';

import './OpsBriefSummary.scss';

interface OpsBriefSummaryProps {
  brief: OperationBriefForm;
  onEdit: () => void;
}

function OpsBriefSummary({ brief, onEdit }: OpsBriefSummaryProps) {
  const { t } = useTranslation();
  const i18nBase =
    'scenes.requirements_operation.components.new_operation_request.brief_summary';

  const uniform =
    OPS_UNIFORMS.find((u) => u.id === brief.uniform)?.label || brief.uniform;

  return (
    <div className="ops-brief-summary">
      <div className="ops-brief-summary__main">
        <div className="ops-brief-summary__title-row">
          <CheckCircleFilled className="ops-brief-summary__check" />
          <div>
            <div className="ops-brief-summary__title">
              {brief.client}
              <span className="ops-brief-summary__dot">·</span>
              {brief.campaign}
            </div>
            <div className="ops-brief-summary__meta">
              {t(`${i18nBase}.week_kam`, {
                week: brief.week,
                kam: brief.kam,
              })}
            </div>
          </div>
        </div>

        <div className="ops-brief-summary__pills">
          <Tag color="blue">{brief.client}</Tag>
          <Tag color="blue">{brief.campaign}</Tag>
          <Tag color="cyan">
            {t(`scenes.requirements_operation.scene.contract.${brief.type}`)}
          </Tag>
          <Tag>{brief.profile}</Tag>
          <Tag>{uniform}</Tag>
          <Tag color="green">{brief.goal}</Tag>
          <Tag color="purple">
            {t(`${i18nBase}.rate`, { amount: formatClp(brief.rate) })}
          </Tag>
          <Tag>
            AM {brief.blocks.am.from}–{brief.blocks.am.to}
          </Tag>
          <Tag>
            PM {brief.blocks.pm.from}–{brief.blocks.pm.to}
          </Tag>
          <Tag>
            FULL {brief.blocks.full.from}–{brief.blocks.full.to}
          </Tag>
        </div>
      </div>

      <Button onClick={onEdit}>{t(`${i18nBase}.buttons.edit`)}</Button>
    </div>
  );
}

export default OpsBriefSummary;
